export const DISPLAY_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PENDING_SHIPMENT: 'pending_shipment',
  PREPARING_SHIPMENT: 'preparing_shipment',
  SHIPPED: 'shipped',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
} as const

export type DisplayStatusType = typeof DISPLAY_STATUS[keyof typeof DISPLAY_STATUS]

export const DISPLAY_STATUS_MAP: Record<DisplayStatusType, string> = {
  [DISPLAY_STATUS.PENDING_PAYMENT]: '待付款',
  [DISPLAY_STATUS.PENDING_SHIPMENT]: '待出貨',
  [DISPLAY_STATUS.PREPARING_SHIPMENT]: '準備出貨',
  [DISPLAY_STATUS.SHIPPED]: '已出貨',
  [DISPLAY_STATUS.CANCELLED]: '取消訂單',
  // 統一訂單狀態為取消訂單：原先訂單狀態有「取消訂單」和「已退款」，但實際上「已退款」不會有更明確的退款狀態（e.g. 退款處理中、退款失敗之交易狀態若只看到已退款會被誤導），統一調整為「取消訂單」呈現
  [DISPLAY_STATUS.REFUNDED]: '取消訂單',
}

/**
 * 允許顯示「取消訂單」按鈕的 display_status 集合。
 *
 * 顯示：pending_payment / pending_shipment / preparing_shipment
 * 不顯示：shipped / cancelled / refunded
 */
export const CANCELABLE_DISPLAY_STATUSES = new Set<DisplayStatusType>([
  DISPLAY_STATUS.PENDING_PAYMENT,
  DISPLAY_STATUS.PENDING_SHIPMENT,
  DISPLAY_STATUS.PREPARING_SHIPMENT,
])
